<div class="common-back-btn-blue" (click)="goLearningMap()"></div>
<div class="card-wrap">
  <div class="card-title">
    智能教练<br>
    专业的一对一服务
  </div>

  <div class="card-content-tips">
    你好，我是Rita，你的智能教练。<br>
    我可以帮你分析管理难题，<br>
    基于DDI 50多年的咨询经验，为你提供解决方案<br>
    想知道我能做些什么？<br>
    快来向我提问吧！
  </div>

  <img src="{{assetsRoute}}/picture/aicoach/card.png" alt="" />

  <div class="card-tips">
    你可以用电脑浏览器打开网址进行试用：<br>
    <span>https://m.transtalent.cn/pc/</span>
  </div>

  <img src="../../assets/picture/aicoach/guide-bottom.png" alt="" />
</div>



// WEBPACK FOOTER //
// ./src/app/app-ai-coach/app-ai-coach.component.html